import CurrentUser from '@frontend/app/features/CurrentUser';
import RailsEnv from '@frontend/app/features/RailsEnv';

export default class DebugLogger {
  constructor(enabled = false) {
    this.enabled = enabled;
  }

  log(message, obj) {
    if (this.enabled && (RailsEnv.isDev() || CurrentUser.isAdmin())) {
      let line;
      const stacktrace = new Error().stack.split('\n');
      if (stacktrace[3].includes('HTMLDocument')) {
        line = stacktrace[2];
      } else {
        line = stacktrace[3];
      }
      const callee = line.trim().split(' ')[1];
      const logMessage = `[debug] ${callee}: ${message}`;
      if (obj) {
        console.log(logMessage, obj);
      } else {
        console.log(logMessage);
      }
    }
  }
}
